"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerCustom = void 0;

var _isDefined = require("../misc-checks/isDefined");

var triggerCustom = function triggerCustom(eventNsp, target, data) {
  var event = new CustomEvent(eventNsp, data);
  target = target instanceof HTMLElement ? target : document.querySelector(target);
  (0, _isDefined.isDefined)(target) && target.dispatchEvent(event);
};

exports.triggerCustom = triggerCustom;